<template>
  <div class="flex width-100">
    <div class="width-100">
      <h2>Create Notification</h2>

      <GridContainer
        form-container
        class="align-left"
      >
        <el-form
          label-position="left"
          @submit.native.prevent
        >
          <el-form-item label="Title">
            <el-input
              v-model="title"
              autofocus
              type="text"
              :placeholder="title"
              clearable
            />
          </el-form-item>

          <el-form-item label="Type">
            <el-select
              v-model="kind"
              value-key="id"
            >
              <el-option
                v-for="item in kindTypes"
                :key="item.id"
                :label="item.value"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="Public?">
            <el-checkbox-group
              v-model="publicNotification"
              size="normal"
            >
              <el-checkbox-button
                v-for="po in publicOptions"
                :key="po.id"
                :label="po.id"
              >
                {{ po.value }}
              </el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="Message">
            <VueEditor v-model="message" />
          </el-form-item>

          <!-- <el-form-item label="Position:">
            <el-input
              v-model="position"
              type="text"
              :placeholder="position"
              clearable
            />
          </el-form-item>

          <el-form-item label="Email:">
            <el-input
              v-model="email"
              type="text"
              :placeholder="email"
              clearable
            />
          </el-form-item>

          <el-form-item label="Phone Number:">
            <el-input
              v-model="phone"
              type="text"
              :placeholder="phone"
              clearable
            />
          </el-form-item>

          <el-button
            type="primary"
            @click="copySignatureCode"
          >
            Copy HTML Code!
          </el-button> -->

          <el-button
            type="primary"
            @click="sendNotification"
          >
            Send Notification
          </el-button>

          <spacer :span="16" />
        </el-form>
      </GridContainer>
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
export default {
  name: 'Notifications',
  components: {
    VueEditor
  },
  data() {
    return {
      title: null,
      message: null,
      kind: null,
      publicNotification: ['CANDIDATES', 'RECRUITERS'],
      publicOptions: [
        { id: 'CANDIDATES', value: 'Candidates' },
        { id: 'RECRUITERS', value: 'Recruiters' }
      ],
      kindTypes: [
        { id: 'WHATS_NEW', value: 'What\'s New' },
        { id: 'NOTIFICATION', value: 'Notification' }
      ]
    }
  },
  methods: {
    sendNotification() {
      this.$store.dispatch('postNotification', {
        title: this.title,
        message: this.message,
        kind: this.kind,
        profiles: [],
        users: [],
        candidatePublic: this.publicNotification.includes('CANDIDATES'),
        recruiterPublic: this.publicNotification.includes('RECRUITERS')
      }).then((res) => {
        this.successNotification('Notification has been sent!')
      })
    }
  }
}
</script>

<style>

</style>
